.el{width:1rem;}